import { useEffect, useRef, useState } from "react"

const useImageLoad = () => {
  const ref = useRef()
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    const element = ref.current

    if (element.complete) {
      // img.naturalWidth === 0 ? error : success
      setIsLoaded(true)

      return
    }

    element.onload = () => {
      if (element.complete) {
        // img.naturalWidth === 0 ? error : success
        setIsLoaded(true)
      }
    }

    return () => {
      element.onload = null
    }
  }, [ref])

  return [ref, isLoaded]
}

export default useImageLoad
